import { render } from "./StackedPlot.vue?vue&type=template&id=12205861"
import script from "./StackedPlot.vue?vue&type=script&lang=js"
export * from "./StackedPlot.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__